import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { ActionsType, SystemType } from 'types/system';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface AboutModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    system: SystemType;
    id?: string;

    //unused props but used in state and getDerivedStateFromProps
    data: any;
    actions: ActionsType | undefined;
}

interface AboutModelState {
    //unused state
    errors: object;

    system: SystemType;

    //unused state
    data: any | null;
}

class AboutModel extends Component<AboutModelProps, AboutModelState> {
    constructor(props: AboutModelProps) {
        super(props);
        this.state = {
            system: props.system,
            data: props.data,
            errors: {},
        };
    }

    static getDerivedStateFromProps(props: AboutModelProps, state: AboutModelState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('About')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-blue-500 text-bold ">{translate('Version')}</div>
                        <div className="text-gray-800 ">{this.state.system.system.version}</div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-blue-500 text-bold ">{translate('Build')}</div>
                        <div className="text-gray-800 ">{this.state.system.system.build}</div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-blue-500 text-bold ">{translate('Date')}</div>
                        <div className="text-gray-800 ">{this.state.system.system.date}</div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-blue-500 text-bold ">{translate('environment')}</div>
                        <div className="text-gray-800 ">{this.state.system.system.serverEnvironment}</div>
                    </div>

                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-blue-500 text-bold underline">
                            <a
                                href="https://portal.usersnap.com/changelog/a1dad8a7-982b-4f91-834e-d9e325e45a6e"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {translate('view changelog')}
                            </a>
                        </div>
                    </div>

                    <div className="flex justify-end hidden">
                        <div className="mt-2">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    system: state.port.system,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AboutModel);
